export default {
  title: {
    id: 'bo_seller.orders.drawers.fix_order_issue.out_of_stock_title',
    defaultMessage: 'Which product is out of stock?',
  },
  subtitle: {
    id: 'bo_seller.orders.drawers.fix_order_issue.out_of_stock_subtitle',
    defaultMessage: 'You can select more than 1 product.',
  },
  sku: {
    id: 'bo_seller.orders.drawers.fix_order_issue.out_of_stock_sku',
    defaultMessage: 'SKU',
  },
  appearance: {
    id: 'bo_seller.orders.drawers.fix_order_issue.out_of_stock_appearance',
    defaultMessage: 'Appearance',
  },
  continue: {
    id: 'bo_seller.orders.drawers.fix_order_issue.out_of_stock_continue',
    defaultMessage: 'Continue',
  },
} as const
